import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const pageVariants = {
  initial: { opacity: 0, scale: 0.96, filter: "blur(6px)" },
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: { opacity: 0, x: -60, filter: "blur(4px)" },
};
function Blog1() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.7, ease: "easeInOut" }}
      style={{ background: "var(--canvas)", minHeight: "100vh" }}
    >
      <div
        style={{
          background:
            "linear-gradient(150deg,#0f0520 0%,#1a0a2e 60%,#0a1828 100%)",
          padding: "100px 6% 70px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 320,
            height: 320,
            borderRadius: "60% 40% 55% 45% / 50% 60% 40% 55%",
            background: "var(--fuchsia)",
            opacity: 0.1,
            top: -80,
            left: -60,
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 220,
            height: 220,
            borderRadius: "60% 40% 55% 45% / 50% 60% 40% 55%",
            background: "var(--gold)",
            opacity: 0.08,
            bottom: -40,
            right: -40,
          }}
        />
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            color: "#c9982a",
            fontWeight: 700,
            fontSize: "0.78rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
        >
          COMMERCIAL SPACES · WALL MURALS
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.8 }}
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontWeight: 900,
            fontSize: "clamp(1.8rem,5vw,3.2rem)",
            color: "#fff",
            lineHeight: 1.2,
            maxWidth: 720,
            margin: "0 auto 24px",
          }}
        >
          How Wall Murals Can Transform Commercial Spaces
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          style={{
            color: "rgba(255,255,255,0.55)",
            fontSize: "0.88rem",
            letterSpacing: "1px",
          }}
        >
          5 min read
        </motion.p>
      </div>
      <div
        style={{
          maxWidth: 780,
          margin: "0 auto",
          padding: "64px 6% 100px",
        }}
      >
        <p
          style={{
            fontSize: "1.1rem",
            lineHeight: 1.85,
            color: "#333",
            marginBottom: "32px",
            borderLeft: "4px solid #c9982a",
            paddingLeft: "20px",
            fontStyle: "italic",
          }}
        >
          In today's competitive business environment, creating a memorable
          customer experience is just as important as offering quality products
          or services. One of the most effective ways to enhance a commercial
          space is through custom wall murals.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 16px",
          }}
        >
          Why Commercial Wall Murals Matter
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "20px" }}>
          A well-designed commercial wall mural does more than decorate a
          wall—it communicates your brand story, creates a unique atmosphere,
          and leaves a lasting impression on visitors. Businesses are
          increasingly investing in custom mural designs to stand out from
          competitors and create spaces that customers remember.
        </p>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "40px" }}>
          For example, a restaurant can use artistic murals to create an
          Instagram-worthy interior, while an office can showcase company values
          and culture through creative wall art. This helps improve customer
          engagement and strengthens brand identity.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 28px",
          }}
        >
          Benefits of Wall Murals for Businesses
        </h2>
        {[
          {
            num: "01",
            title: "Strengthen Brand Identity",
            desc: "Custom wall murals can incorporate company colors, logos, and messaging, helping businesses build a consistent and professional brand image.",
          },
          {
            num: "02",
            title: "Enhance Customer Experience",
            desc: "Visually appealing interiors encourage customers to spend more time in your space, leading to better engagement and positive impressions.",
          },
          {
            num: "03",
            title: "Improve Workplace Environment",
            desc: "In offices, murals can inspire creativity, boost employee morale, and create a more productive work atmosphere.",
          },
          {
            num: "04",
            title: "Increase Social Media Visibility",
            desc: "Unique mural artwork often encourages customers to take photos and share them online, providing free marketing and increasing brand exposure.",
          },
        ].map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "28px",
              padding: "24px",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
              border: "1px solid #f0ece4",
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "2rem",
                fontWeight: 800,
                color: "#c9982a",
                opacity: 0.4,
                lineHeight: 1,
                flexShrink: 0,
              }}
            >
              {item.num}
            </span>
            <div>
              <strong
                style={{
                  display: "block",
                  fontSize: "1rem",
                  fontWeight: 700,
                  color: "#1a0a2e",
                  marginBottom: "6px",
                }}
              >
                {item.title}
              </strong>
              <p style={{ lineHeight: 1.75, color: "#555", margin: 0 }}>
                {item.desc}
              </p>
            </div>
          </motion.div>
        ))}
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 16px",
          }}
        >
          Choose Professional Mural Artists
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "20px" }}>
          Whether you're looking for office wall murals, restaurant wall art,
          retail store murals, or commercial wall painting services, working
          with experienced mural artists ensures a high-quality and long-lasting
          result.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 16px",
          }}
        >
          Transform Your Commercial Space
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "44px" }}>
          Investing in a custom wall mural is more than an aesthetic
          upgrade—it's a strategic branding tool that enhances customer
          experience, improves visual appeal, and helps businesses stand out. If
          you're planning to transform your commercial space, professional mural
          design can make a powerful impact.
        </p>
        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
          <Link to="/services/wall-murals" style={{ textDecoration: "none" }}>
            <motion.button
              whileHover={{ background: "#b8882a" }}
              style={{
                padding: "13px 28px",
                background: "#c9982a",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                cursor: "pointer",
                textTransform: "uppercase",
                transition: "background 0.3s",
              }}
            >
              View Wall Murals
            </motion.button>
          </Link>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <motion.button
              whileHover={{ background: "#f0ece4" }}
              style={{
                padding: "13px 28px",
                background: "transparent",
                color: "#1a0a2e",
                border: "1.5px solid #1a0a2e",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                cursor: "pointer",
                textTransform: "uppercase",
                transition: "background 0.3s",
              }}
            >
              Get a Quote
            </motion.button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
export default Blog1;
